// extracted by mini-css-extract-plugin
export default {"quickLinks":"brand-quick-links-QuickLinksLite__quickLinks--2A99K"};